(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * View script
 * @package concept83
 * @since 1.0
 */
var CustomVideoControls = /*#__PURE__*/function () {
  function CustomVideoControls(elem) {
    (0, _classCallCheck2.default)(this, CustomVideoControls);
    this.elem = elem;
    this.video = elem.querySelector('video');
    this.iframe = elem.querySelector('iframe');
    if (this.video) {
      this.isHidden = undefined;
      this.poster = this.video.parentElement.previousElementSibling;
      this.posterPlayBtn = this.poster.querySelector('a');
      this.playerSettings = this.video.nextElementSibling.dataset.playerSettings;
      this.options = this.playerSettings && JSON.parse(this.playerSettings);
      this.base = '.wp-block-cnc83-video__';
      this.icoBase = '.cnc83-theme-ico__player-';
      this.container = this.video.parentElement;
      this.controls = this.video.nextElementSibling;
      this.timeline = this.container.querySelector("".concat(this.base, "timeline"));
      this.progress = this.timeline.querySelector("".concat(this.base, "timeline-track"));
      this.bar = this.progress.querySelector('span');
      this.buttons = this.container.querySelector("".concat(this.base, "buttons"));
      this.playBtn = this.buttons.querySelector("".concat(this.base, "play"));
      this.icoPlay = this.playBtn.querySelector("".concat(this.icoBase, "start"));
      this.icoPause = this.playBtn.querySelector("".concat(this.icoBase, "pause"));
      this.stopBtn = this.buttons.querySelector("".concat(this.base, "stop"));
      this.backBtn = this.buttons.querySelector("".concat(this.base, "backward"));
      this.forwardBtn = this.buttons.querySelector("".concat(this.base, "forward"));
      this.expandBtn = this.buttons.querySelector("".concat(this.base, "expand"));
      this.downloadBtn = this.buttons.querySelector("".concat(this.base, "download"));
      this.timer = this.buttons.querySelector("".concat(this.base, "time"));
      this.hours = this.timer.querySelector("".concat(this.base, "time-hours"));
      this.minutes = this.timer.querySelector("".concat(this.base, "time-minutes"));
      this.seconds = this.timer.querySelector("".concat(this.base, "time-seconds"));
      this.videoInit();
      this.videoController();
    }
    if (this.iframe) {
      this.poster = this.iframe.parentElement.previousElementSibling;
      this.posterPlayBtn = this.poster && this.poster.querySelector('a');
      this.iframeInit();
    }
  }
  (0, _createClass2.default)(CustomVideoControls, [{
    key: "setPauseState",
    value: function setPauseState(value) {
      if (value) {
        this.icoPlay.style.display = 'block';
        this.icoPause.style.display = 'none';
      } else {
        this.icoPlay.style.display = 'none';
        this.icoPause.style.display = 'block';
      }
    }
  }, {
    key: "updateTimer",
    value: function updateTimer(currentTime) {
      var hours = Math.floor(currentTime / 3600);
      var minutes = Math.floor((currentTime - hours * 3600) / 60);
      var seconds = Math.floor(currentTime - hours * 3600 - minutes * 60);
      if (hours < 10) hours = '0' + hours;
      if (minutes < 10) minutes = '0' + minutes;
      if (seconds < 10) seconds = '0' + seconds;
      this.hours.innerHTML = hours;
      this.minutes.innerHTML = minutes;
      this.seconds.innerHTML = seconds;
      return false;
    }
  }, {
    key: "updateCurrentTime",
    value: function updateCurrentTime(event) {
      var progress = this.video.currentTime / this.video.duration * 100;
      if (this.video.ended && !this.options.loop) {
        this.setPauseState(true);
      }
      this.updateTimer(this.video.currentTime);
      this.bar.style.width = "".concat(progress, "%");
    }
  }, {
    key: "scrub",
    value: function scrub(event) {
      var rect = this.progress.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var unit = this.video.duration / this.progress.clientWidth;
      this.video.currentTime = x * unit;
      this.updateCurrentTime();
    }
  }, {
    key: "play",
    value: function play(event) {
      var posterPlay = event.target.closest('a');
      if (posterPlay && posterPlay.getAttribute('title') === 'Play') {
        this.video.play();
        this.setPauseState(false);
      } else {
        if (this.video.paused || this.video.ended && !this.options.loop) {
          this.video.play();
          this.setPauseState(false);
        } else {
          this.video.pause();
          this.setPauseState(true);
        }
      }
    }
  }, {
    key: "stop",
    value: function stop(event) {
      this.video.pause();
      this.video.currentTime = 0;
      this.setPauseState(true);
    }
  }, {
    key: "rewind",
    value: function rewind(event) {
      this.video.currentTime = this.video.currentTime - this.video.duration / 100 * this.options.skip;
    }
  }, {
    key: "forward",
    value: function forward(event) {
      this.video.currentTime = this.video.currentTime + this.video.duration / 100 * this.options.skip;
    }
  }, {
    key: "fullScreenMode",
    value: function fullScreenMode(event) {
      event.preventDefault();
      if (document.fullscreenElement !== null) {
        document.exitFullscreen();
      } else {
        this.video.requestFullscreen();
      }
    }
  }, {
    key: "download",
    value: function download(event) {
      event.preventDefault();
      var link = document.createElement('a');
      link.href = this.video.src;
      link.target = "_blank";
      link.download = "";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, {
    key: "toggleController",
    value: function toggleController(value) {
      var _this = this;
      var className = 'cnc83-hidden-controls';
      if (value) {
        this.isHidden = setTimeout(function () {
          _this.controls.classList.add(className);
        }, this.options.controlsDelay || 3000);
      } else {
        if (typeof this.isHidden === 'number') {
          clearTimeout(this.isHidden);
        }
        this.controls.classList.remove(className);
      }
      return this.isHidden;
    }
  }, {
    key: "parseOptions",
    value: function parseOptions() {
      var o = _objectSpread({}, this.options);
      o.skip = parseInt(o.skip);
      o.controlsDelay = parseInt(o.controlsDelay) * 1000;
      this.options = _objectSpread(_objectSpread({}, this.options), o);
      return this.options;
    }
  }, {
    key: "videoInit",
    value: function videoInit() {
      this.parseOptions();
      this.video.controls = false;
      if (!this.options.allowFullscreen) {
        this.expandBtn.style.display = 'none';
      }
      if (!this.options.allowDownload) {
        this.downloadBtn.style.display = 'none';
      }
      if (!this.video.paused && !this.video.ended) {
        this.setPauseState(true);
      }
      this.toggleController(true);
    }
  }, {
    key: "videoController",
    value: function videoController() {
      var _this2 = this;
      this.playBtn.addEventListener('click', function (event) {
        return _this2.play(event);
      });
      this.posterPlayBtn.addEventListener('click', function (event) {
        return _this2.play(event);
      });
      this.stopBtn.addEventListener('click', function (event) {
        return _this2.stop(event);
      });
      this.backBtn.addEventListener('click', function (event) {
        return _this2.rewind(event);
      });
      this.forwardBtn.addEventListener('click', function (event) {
        return _this2.forward(event);
      });
      this.expandBtn && this.expandBtn.addEventListener('click', function (event) {
        return _this2.fullScreenMode(event);
      });
      this.downloadBtn && this.downloadBtn.addEventListener('click', function (event) {
        return _this2.download(event);
      });
      this.video.addEventListener('timeupdate', function (event) {
        return _this2.updateCurrentTime(event);
      });
      this.container.addEventListener('mouseover', function (event) {
        return _this2.toggleController(false);
      });
      this.container.addEventListener('mouseout', function (event) {
        return _this2.toggleController(true);
      });
      this.progress.addEventListener('click', function (event) {
        return _this2.scrub(event);
      });
    }
  }, {
    key: "iframeInit",
    value: function iframeInit() {
      var isYouTube = this.iframe.src.includes('https://www.youtube.com');
      // const isVimeo = 'https://css-tricks.com/play-button-youtube-and-vimeo-api/'

      if (isYouTube && YT) {
        this.iframe.src = "".concat(this.iframe.src);
        this.ytController();
      }
    }
  }, {
    key: "ytController",
    value: function ytController() {
      var _this3 = this;
      var player = null;
      var playerContainer = this.iframe.parentElement.closest('.wp-block-cnc83-video__container');
      var vidWidth = playerContainer.clientWidth;
      var vidHeight = vidWidth * 0.563;
      var url = new URL(this.iframe.src);
      var pathArray = url.pathname.split('/');
      var videoId = pathArray.findIndex(function (el) {
        return el === 'embed';
      }) + 1;
      var playerArgs = {
        width: vidWidth,
        height: vidHeight,
        videoId: pathArray[videoId],
        playerVars: {
          'playsinline': 1,
          'autoplay': url.searchParams.get('autoplay'),
          'fs': url.searchParams.get('fs'),
          'loop': url.searchParams.get('loop'),
          'controls': url.searchParams.get('controls'),
          'rel': url.searchParams.get('rel'),
          'start': url.searchParams.get('start'),
          'end': url.searchParams.get('end'),
          'iv_load_policy': url.searchParams.get('iv_load_policy')
        },
        events: {
          'onReady': function onReady(event) {
            _this3.posterPlayBtn && _this3.posterPlayBtn.addEventListener('click', function (event) {
              return player.playVideo();
            });
          }
        }
      };
      if (url.searchParams.has('playlist')) {
        playerArgs.playerVars.plalist = url.searchParams.get('playlist');
      }
      if (url.searchParams.has('listType') && url.searchParams.has('list')) {
        playerArgs.playerVars.listType = url.searchParams.get('listType');
        playerArgs.playerVars.list = url.searchParams.get('list');
      }
      window.YT.ready(function () {
        player = new YT.Player(_this3.iframe.parentElement, playerArgs);
        window.addEventListener('resize', function (event) {
          player.destroy();
          vidWidth = playerContainer.clientWidth;
          vidHeight = vidWidth * 0.563;
          player = new YT.Player(_this3.iframe.parentElement, _objectSpread(_objectSpread({}, playerArgs), {
            width: vidWidth,
            height: vidHeight
          }));
        });
      });
    }
  }]);
  return CustomVideoControls;
}();
(0, _toConsumableArray2.default)(document.querySelectorAll('.wp-block-cnc83-video')).forEach(function (video) {
  return new CustomVideoControls(video);
});

},{"@babel/runtime/helpers/classCallCheck":4,"@babel/runtime/helpers/createClass":5,"@babel/runtime/helpers/defineProperty":6,"@babel/runtime/helpers/interopRequireDefault":7,"@babel/runtime/helpers/toConsumableArray":10}],2:[function(require,module,exports){
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],3:[function(require,module,exports){
var arrayLikeToArray = require("./arrayLikeToArray.js");
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayLikeToArray.js":2}],4:[function(require,module,exports){
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],5:[function(require,module,exports){
var toPropertyKey = require("./toPropertyKey.js");
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./toPropertyKey.js":12}],6:[function(require,module,exports){
var toPropertyKey = require("./toPropertyKey.js");
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./toPropertyKey.js":12}],7:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],8:[function(require,module,exports){
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],9:[function(require,module,exports){
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],10:[function(require,module,exports){
var arrayWithoutHoles = require("./arrayWithoutHoles.js");
var iterableToArray = require("./iterableToArray.js");
var unsupportedIterableToArray = require("./unsupportedIterableToArray.js");
var nonIterableSpread = require("./nonIterableSpread.js");
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayWithoutHoles.js":3,"./iterableToArray.js":8,"./nonIterableSpread.js":9,"./unsupportedIterableToArray.js":14}],11:[function(require,module,exports){
var _typeof = require("./typeof.js")["default"];
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./typeof.js":13}],12:[function(require,module,exports){
var _typeof = require("./typeof.js")["default"];
var toPrimitive = require("./toPrimitive.js");
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./toPrimitive.js":11,"./typeof.js":13}],13:[function(require,module,exports){
function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],14:[function(require,module,exports){
var arrayLikeToArray = require("./arrayLikeToArray.js");
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayLikeToArray.js":2}]},{},[1]);
